/**
 * Main app
 *
 */

"use strict";

import { ProgressStars } from './progress-stars.js';
import { Leadership } from './leadership.js';
import { Lightbox } from './lightbox.js';
import { SwiperControls } from './swiper.js'; 
import { Popover, Modal } from 'bootstrap';
import { StickyFooter } from './sticky-footer.js'; 

class App {
  constructor()
  {
    this.init_menu();
    this.init_custom_events();
    this.init_popovers();
    this.init_exit_modal();

    const progress_stars = new ProgressStars();
    const leadership = new Leadership();
    const lightbox = new Lightbox();
    const swiper = new SwiperControls();
    const sticky_footer = new StickyFooter();
  }

  /**
   * Add hover to menu dropdowns
   * 
   */
  init_menu()
  {
    document.querySelectorAll('header ul.navbar-nav li.dropdown')?.forEach( (item) => {
      item.addEventListener('mouseenter', () => {
        if ( window.innerWidth >= 992 ) {
          item.lastElementChild.classList.add('show');
        }
      });
    
      item.addEventListener('mouseleave', () => {
        if ( window.innerWidth >= 992 ) {
          item.lastElementChild.classList.remove('show');
        }
      });
    });
  }

  /**
   * Init custom events
   * 
   */
  init_custom_events()
  {
    window.dataLayer = window.dataLayer || [];

    // Toggle the form progress bar
    document.addEventListener('form:stepChange', ( e ) => {
      
    });

    // Fire dataLayer events
    document.addEventListener('form:afterSubmit', ( e ) => {

    });
  }

  init_popovers()
  {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
  }

  /**
   * Exit modal
   * 
   */
  init_exit_modal()
  {
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    if ( document.getElementById('site-popup') && !getCookie('already_displayed_site_popup') ) {
      const siteModal = new Modal(document.getElementById('site-popup'));

      document.addEventListener('mouseleave', () => {
        if ( !getCookie('already_displayed_site_popup') )
          siteModal.show();

        setCookie('already_displayed_site_popup', true, 86400);
      });
    }
  }
}

const app = new App();
